import { gql } from 'graphql-tag';

export const SIMILAR_GEO_IDS = gql`
    query similarGeoIds($geoIds: [String!]!) {
        similarGeoIds(geoIds: $geoIds) {
            similarGeoIds {
                identifier
                label
            }
            geoId
        }
    }
`;
